module.exports = {"530681001":"云富街道","530681101":"向家坝镇","530681102":"太平镇","530681103":"两碗镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530681.json
// module id = 2590
// module chunks = 0